// extracted by css-extract-rspack-plugin
export default {"mobile-wrapper":"MobileWrapper_mobile-wrapper__j71o1","mobile-wrapper-list-view":"MobileWrapper_mobile-wrapper-list-view__aiyon"};